
<template>
    <form class="form" @submit="submit">
        <div class="double">
            <FormInput
                v-bind:value.sync="email"
                v-bind:type="'email'"
                name="email"
                class="first"
                ref="formInput"
            >
                {{page.email}}
            </FormInput>
            <FormInput
                v-model="country"
                class="second"
                name="country"
                ref="formInput"
            >
                {{page.country}}
            </FormInput>
        </div>
        <div class="double">
            <FormInput
                v-model="projectType"
                class="first"
                name="project-type"
                ref="formInput"
            >
                {{page.projecttype}}
            </FormInput>
            <FormInput
                v-model="company"
                class="second"
                name="company"
                ref="formInput"
            >
                {{page.company}}
            </FormInput>
        </div>
        <FormInput
            v-model="message"
            :type="'textarea'"
            class="alone"
            name="message"
            ref="formInput"
        >
            {{page.message}}
        </FormInput>
        <div class="align-right">
            <router-link class="out-link" :to="{ name: 'TechnicalGuide' }"><IconArrow/>{{$t('technicalguide.downloadtechnicalguide')}}</router-link>

            <Cta @click.native="submit" :direction="'none'" :class="{disabled: fetching}">{{page.send}}</Cta>
        </div>
    </form>
</template>
<script>
import Cta from '@/components/Cta'
import FormInput from './FormInput'
import IconArrow from '@/components/IconArrow'
import {generalRequest} from '@/store/api/CRM'
export default {
    components: {
        Cta,
        FormInput,
        IconArrow
    },
    props: {
        page: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            email: '',
            country: '',
            projectType: '',
            company: '',
            message: '',
            fetching: false
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();
            this.fetching = true
            const {email, country, projectType, company, message} = this
            generalRequest({email, country, projectType, company, message})
                .then(res => {
                    this.$children.forEach(_ => {
                        if(_.$options.name === 'form-input') {
                            _.inputVal = ''
                        }
                    })
                    this.fetching = false
                })
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.form
    // padding: 400px 0 200px 0
    height: 100vh
    width: 100vw
    position: absolute
    top: 0
    left: 0
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    padding-left: 9.6%
    padding-right: 9.6%
    padding-top: 160px
    overflow: auto
    overscroll-behavior: none
.alone, .double, .align-right
    display: block
    margin: 0 auto 66px
    max-width: 860px
    width: 100%
    @include media-breakpoint-down($sm)
        margin-bottom: 33px
.double
    display: flex
    @include media-breakpoint-down($md)
        display: block
    .first
        flex: 1
    .second
        width: 40%
        margin-left: 20px
        @include media-breakpoint-down($md)
            width: 100%
            margin-left: 0
            margin-top: 66px
        @include media-breakpoint-down($sm)
            margin-top: 33px
.align-right
    text-align: right
    display: flex
    align-items: center
    justify-content: space-between
    @include media-breakpoint-down($sm)
        flex-direction: column-reverse
.cta
    &.disabled
        pointer-events: none
        opacity: .15
.out-link
    display: flex
    text-decoration: none
    white-space: nowrap
    font-weight: 500
    // position: absolute
    // left: 0
    // bottom: 0
    // margin-left: 5.8%
    @include media-breakpoint-down($sm)
        position: static
        margin-left: 0
        font-size: 11px
        margin-top: 4em
    svg
        margin-right: 1em
</style>
